import { Component, ErrorInfo } from 'react';

export class ErrorBoundary extends Component<{
    fallback: (error?: Error) => React.ReactNode;
}> {
    state: { hasError: boolean; error?: Error } = { hasError: false };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(error, errorInfo);
        this.setState({ hasError: true, error });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback(this.state.error);
        }

        return this.props.children;
    }
}
